import { AppProvider } from "./appContext.js";
import { MSProvider } from "./matchseekerContext.js";
import { BGProvider } from "./bgprofileContext.js";
import { ReportsProvider } from "./reportsAppContext.js";
import { PVProvider } from "./profileVerificationContext.js";
import { SAMProvider } from "./samContext.js";
import { SUBProvider } from "./subContext.js";
import { SupportProvider } from "./supportContext.js";

const CombinedProvider = ({ children }) => {
  return (
    <AppProvider>
      <MSProvider>
        <BGProvider>
          <ReportsProvider>
            <PVProvider>
              <SAMProvider>
                <SUBProvider>
                  <SupportProvider>{children}</SupportProvider>
                </SUBProvider>
              </SAMProvider>
            </PVProvider>
          </ReportsProvider>
        </BGProvider>
      </MSProvider>
    </AppProvider>
  );
};

export default CombinedProvider;
